import React from 'react';
import { EmptyState, EmptyStateBody } from '@patternfly/react-core';
import { CpuIcon } from '@patternfly/react-icons';

const ServerHardwareTab: React.FunctionComponent = () => (
  <EmptyState
    titleText="Hardware information coming soon."
    icon={CpuIcon}
    variant="lg"
    headingLevel="h2"
    style={{ marginTop: '1rem' }}
  >
    <EmptyStateBody>Disk, memory, and CPU details will be displayed here.</EmptyStateBody>
  </EmptyState>
);

export default ServerHardwareTab;
